import { BACKGROUND_HEADER } from '@kanos/domain';
import createClient from 'openapi-fetch';
const SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);
/** A client whose paths, bodies, responses and errors follow the OpenAPI document. */
export function createApiClient({ csrfToken, background = () => false, baseUrl = '', fetch, }) {
    const client = createClient({
        baseUrl,
        headers: { accept: 'application/json' },
        ...(fetch ? { fetch } : {}),
    });
    client.use({
        onRequest({ request }) {
            const token = SAFE_METHODS.has(request.method) ? undefined : csrfToken();
            if (token)
                request.headers.set('X-CSRF-Token', token);
            if (background())
                request.headers.set(BACKGROUND_HEADER, '1');
            return request;
        },
    });
    return client;
}
//# sourceMappingURL=index.js.map